// SegmentedBar.tsx
import React from "react";
import MDBox from "components/MDBox";

interface SegmentedBarProps {
  total: number;
  filled: number;
}

const SegmentedBar: React.FC<SegmentedBarProps> = ({ total, filled }) => {
  return (
    <MDBox
      display="flex"
      width="100%"
      height="8px"
      borderRadius="4px"
      overflow="hidden"
      mt="0rem"
    >
      {Array.from({ length: total }).map((_, index) => (
        <MDBox
          key={index}
          flex="1"
          sx={{
            backgroundColor: index < filled ? "green" : "#ccc",
          }}
        />
      ))}
    </MDBox>
  );
};

export default SegmentedBar;
